import React, { useState } from "react";

import { useAuth } from "@/customHooks/useAuth";
import { useProfile } from "@/customHooks/useProfile";
import { withoutAuthToast } from "@/utils/withoutAuthToast";
import { useTranslation } from "next-i18next";

import { CreateFolderDrawer } from "@/components/blocks/search/create-folder-drawer/CreateFolderDrawer";
import { FavouriteFolder } from "@/components/blocks/search/favourite-folder/FavouriteFolder";
import { FolderDrawer } from "@/components/blocks/search/folder-drawer/FolderDrawer";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  useMediaQuery,
  useTheme
} from "@mui/material";

import FolderIcon from "~public/icons/Folder/Folder.svg";

export const FavouritesSection = (props: any): JSX.Element => {
  const { t } = useTranslation("searchpage");
  const theme = useTheme();
  const isGreaterThanTablet = useMediaQuery(theme.breakpoints.up("md"));
  const { session } = useAuth();
  const { getFoldersFull } = useProfile();
  const { data: fullData, isLoading } = getFoldersFull();
  const [isCreateFolderDrawerOpen, setIsCreateFolderDrawerOpen] =
    useState<boolean>(false);
  const [isFolderContentDrawerOpen, setIsFolderContentDrawerOpen] =
    useState<boolean>(false);
  const [folderDrawerContent, setFolderDrawerContent] = useState<any>(null);

  const handleOpenCreateFolderDrawer = () => {
    setIsCreateFolderDrawerOpen(true);
  };
  const toggleCreateFolderDrawer = () => {
    if (!session) {
      return withoutAuthToast();
    }

    setIsCreateFolderDrawerOpen(prev => !prev);
  };

  const handleFolderContentDrawerClose = () => {
    setIsFolderContentDrawerOpen(false);
  };

  const handleOpenFolder = (folder: any) => {
    setFolderDrawerContent(folder);
    setIsFolderContentDrawerOpen(true);
  };

  return (
    <Container
      sx={{
        display: { md: "grid" },
        gridTemplateColumns: { md: "repeat(2, 1fr)" },
        // flexDirection: { md: "row" },
        // justifyContent: { md: "space-between" },
        margin: { xs: "0 0 16px", md: "0 auto 16px auto" },
        gap: { md: "20px" }
      }}>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}>
          <CircularProgress sx={{ m: "auto" }} size={24} color={"primary"} />
        </Box>
      ) : (
        <>
          {isGreaterThanTablet ? (
            <>
              {fullData.results?.length > 0 &&
                fullData.results.map((folder: any) => {
                  if (!folder?.pk) return;

                  return (
                    <Box
                      flex={1}
                      width={"100%"}
                      key={folder.pk}
                      onClick={() => handleOpenFolder(folder)}>
                      <FavouriteFolder key={folder.pk} folder={folder} />
                    </Box>
                  );
                })}
            </>
          ) : (
            <Box
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection={"column"}
              sx={{
                maxWidth: { md: "560px" },
                width: { md: "100%" }
              }}
              gap={2}>
              {fullData.results?.length > 0 &&
                fullData.results.map((folder: any) => {
                  if (!folder?.pk) return;

                  return (
                    <Box
                      flex={1}
                      width={"100%"}
                      key={folder.pk}
                      onClick={() => handleOpenFolder(folder)}>
                      <FavouriteFolder key={folder.pk} folder={folder} />
                    </Box>
                  );
                })}
            </Box>
          )}
        </>
      )}

      <Button
        onClick={handleOpenCreateFolderDrawer}
        sx={{
          height: 163,
          borderRadius: 2,
          mt: { xs: 2, md: 0 },
          maxWidth: { md: "560px" }
        }}
        fullWidth
        variant={"outlined"}
        color={"pink"}
        startIcon={<FolderIcon />}>
        {t("favourites.create-folder")}
      </Button>
      {folderDrawerContent && (
        <FolderDrawer
          isOpen={isFolderContentDrawerOpen}
          handleClose={handleFolderContentDrawerClose}
          folder={folderDrawerContent}
        />
      )}
      <CreateFolderDrawer
        isOpen={isCreateFolderDrawerOpen}
        toggleDrawer={toggleCreateFolderDrawer}
        folders={fullData}
      />
    </Container>
  );
};
